import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsStoragePluginModule, STORAGE_ENGINE } from '@ngxs/storage-plugin';
import { UiModule } from '../ui/ui.module';
import { ActiveGuard } from './auth/active.guard';
import { AuthGuard } from './auth/auth.guard';
import { DraftGuard } from './auth/draft.guard';
import { PaidGuard } from './auth/paid.guard';
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { MobileAccessWarningComponent } from './components/mobile-access-warning/mobile-access-warning.component';
import { UpgradeOfferComponent } from './components/upgrade-offer/upgrade-offer.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { SAVED_TO_LOCAL_STORAGE_NGXS } from './constants/constants';
import { BearerInterceptor } from './http/bearer.interceptor';
import { StorageEngineNgxs } from './StorageEngineNgxs';

@NgModule({
  declarations: [
    UserMenuComponent,
    MobileAccessWarningComponent,
    UpgradeOfferComponent,
    LanguageSwitcherComponent,
  ],
  imports: [
    FontAwesomeModule,
    TranslateModule,
    CommonModule,
    NgxsStoragePluginModule.forRoot({
      keys: SAVED_TO_LOCAL_STORAGE_NGXS,
    }),
    UiModule,
  ],
  providers: [
    AuthGuard,
    PaidGuard,
    DraftGuard,
    ActiveGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BearerInterceptor,
      multi: true,
    },
    {
      provide: STORAGE_ENGINE,
      useClass: StorageEngineNgxs,
    },
  ],
  exports: [
    UserMenuComponent,
    MobileAccessWarningComponent,
    UpgradeOfferComponent,
    LanguageSwitcherComponent,
  ],
})
export class CoreModule {}
